import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';
import * as api from '@modules/appeals/api/waitingRoom';

const namespace = 'APPEALS/WAITINGROOM';

export const FETCH_WAITING_ROOMS = createRequestTypes(
  `${namespace}/FETCH_WAITING_ROOMS`,
);

export const fetchWaitingRooms = makeApiActionCreatorV3(
  api.fetchWaitingRooms,
  FETCH_WAITING_ROOMS[START],
  FETCH_WAITING_ROOMS[SUCCESS],
  FETCH_WAITING_ROOMS[ERROR],
);

export const FETCH_DOCKET_GROUP_CODES = createRequestTypes(
  `${namespace}/FETCH_DOCKET_GROUP_CODES`,
);

export const fetchDocketGroupCodes = makeApiActionCreatorV3(
  api.fetchDocketGroupCodes,
  FETCH_DOCKET_GROUP_CODES[START],
  FETCH_DOCKET_GROUP_CODES[SUCCESS],
  FETCH_DOCKET_GROUP_CODES[ERROR],
);

export const MOVE_CHECK_IN_ITEM = createRequestTypes(
  `${namespace}/MOVE_CHECK_IN_ITEM`,
);

export const moveCheckInItem = makeApiActionCreatorV3(
  api.moveCheckInItem,
  MOVE_CHECK_IN_ITEM[START],
  MOVE_CHECK_IN_ITEM[SUCCESS],
  MOVE_CHECK_IN_ITEM[ERROR],
);

export const ASSIGN_DIRECTLY = createRequestTypes(
  `${namespace}/ASSIGN_DIRECTLY`,
);

export const assignDirectly = makeApiActionCreatorV3(
  api.assignDirectly,
  ASSIGN_DIRECTLY[START],
  ASSIGN_DIRECTLY[SUCCESS],
  ASSIGN_DIRECTLY[ERROR],
);

export const FETCH_WAITING_ROOM_BY_APPRAISER = createRequestTypes(
  `${namespace}/FETCH_WAITING_ROOM_BY_APPRAISER`,
);

export const fetchWaitingRoomByAppraiser = makeApiActionCreatorV3(
  api.fetchWaitingRoomByAppraiser,
  FETCH_WAITING_ROOM_BY_APPRAISER[START],
  FETCH_WAITING_ROOM_BY_APPRAISER[SUCCESS],
  FETCH_WAITING_ROOM_BY_APPRAISER[ERROR],
);

export const FETCH_APPRAISER_OVERVIEW = createRequestTypes(
  `${namespace}/FETCH_APPRAISER_OVERVIEW`,
);

export const fetchAppraiserOverview = makeApiActionCreatorV3(
  api.fetchAppraiserOverview,
  FETCH_APPRAISER_OVERVIEW[START],
  FETCH_APPRAISER_OVERVIEW[SUCCESS],
  FETCH_APPRAISER_OVERVIEW[ERROR],
);

export const FETCH_AGENT_DOCKET_GROUPS = createRequestTypes(
  `${namespace}/FETCH_AGENT_DOCKET_GROUPS`,
);

export const fetchAgentDocketGroups = makeApiActionCreatorV3(
  api.fetchAgentDocketGroups,
  FETCH_AGENT_DOCKET_GROUPS[START],
  FETCH_AGENT_DOCKET_GROUPS[SUCCESS],
  FETCH_AGENT_DOCKET_GROUPS[ERROR],
);

export const MOVE_AGENT_DOCKET_GROUP_CHECK_IN_ITEM = createRequestTypes(
  `${namespace}/MOVE_AGENT_DOCKET_GROUP_CHECK_IN_ITEM`,
);

export const moveAgentDocketGroupCheckInItem = makeApiActionCreatorV3(
  api.moveAgentDocketGroupCheckInItem,
  MOVE_AGENT_DOCKET_GROUP_CHECK_IN_ITEM[START],
  MOVE_AGENT_DOCKET_GROUP_CHECK_IN_ITEM[SUCCESS],
  MOVE_AGENT_DOCKET_GROUP_CHECK_IN_ITEM[ERROR],
);

export const ASSIGN_AGENT_DOCKET_GROUP_DIRECTLY = createRequestTypes(
  `${namespace}/ASSIGN_AGENT_DOCKET_GROUP_DIRECTLY`,
);

export const assignAgentDocketGroupDirectly = makeApiActionCreatorV3(
  api.assignAgentDocketGroupDirectly,
  ASSIGN_AGENT_DOCKET_GROUP_DIRECTLY[START],
  ASSIGN_AGENT_DOCKET_GROUP_DIRECTLY[SUCCESS],
  ASSIGN_AGENT_DOCKET_GROUP_DIRECTLY[ERROR],
);

export const FETCH_WAITING_ROOMS_INFORMAL = createRequestTypes(
  `${namespace}/FETCH_WAITING_ROOMS_INFORMAL`,
);

export const fetchWaitingRoomsInformal = makeApiActionCreatorV3(
  api.fetchWaitingRoomsInformal,
  FETCH_WAITING_ROOMS_INFORMAL[START],
  FETCH_WAITING_ROOMS_INFORMAL[SUCCESS],
  FETCH_WAITING_ROOMS_INFORMAL[ERROR],
);

export const MOVE_CHECK_IN_ITEM_INFORMAL = createRequestTypes(
  `${namespace}/MOVE_CHECK_IN_ITEM_INFORMAL`,
);

export const moveCheckInItemInformal = makeApiActionCreatorV3(
  api.moveCheckInItemInformal,
  MOVE_CHECK_IN_ITEM_INFORMAL[START],
  MOVE_CHECK_IN_ITEM_INFORMAL[SUCCESS],
  MOVE_CHECK_IN_ITEM_INFORMAL[ERROR],
);

export const ASSIGN_DIRECTLY_INFORMAL = createRequestTypes(
  `${namespace}/ASSIGN_DIRECTLY_INFORMAL`,
);

export const assignDirectlyInformal = makeApiActionCreatorV3(
  api.assignDirectlyInformal,
  ASSIGN_DIRECTLY_INFORMAL[START],
  ASSIGN_DIRECTLY_INFORMAL[SUCCESS],
  ASSIGN_DIRECTLY_INFORMAL[ERROR],
);

export const FETCH_APPEAL_MEETING_LINK = createRequestTypes(
  `${namespace}/FETCH_APPEAL_MEETING_LINK`,
);

export const fetchAppealMeetingLink = makeApiActionCreatorV3(
  api.fetchAppealMeetingLink,
  FETCH_APPEAL_MEETING_LINK[START],
  FETCH_APPEAL_MEETING_LINK[SUCCESS],
  FETCH_APPEAL_MEETING_LINK[ERROR],
);

export const SORT_ALL_ROOM_RECORDS = createRequestTypes(
  `${namespace}/SORT_ALL_ROOM_RECORDS`,
);

export const sortAllRoomRecords = makeApiActionCreatorV3(
  api.sortAllRoomRecords,
  SORT_ALL_ROOM_RECORDS[START],
  SORT_ALL_ROOM_RECORDS[SUCCESS],
  SORT_ALL_ROOM_RECORDS[ERROR],
);